<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import resizeMixin from '@/mixins/resizeMixin'
import { isMobileDevice, pathMap, pcMap } from '@/router'

export default {
  name: 'App',
  // 混入窗口尺寸监听：尺寸稳定（防抖 150ms）后自动调用 handleResize
  mixins: [resizeMixin],
  data() {
    return {
      // 当前布局模式：'pc' | 'mobile'，用于避免重复跳转
      currentMode: ''
    }
  },
  created() {
    // 初始化当前模式（与初始路由保持一致），避免首帧误触发跳转
    this.syncModeFromRoute(this.$route.path)
  },
  watch: {
    // 路由变化时同步模式，保证状态始终与当前页面一致
    '$route.path'(path) {
      this.syncModeFromRoute(path)
    }
  },
  methods: {
    // 根据路径判断当前处于哪种模式
    syncModeFromRoute(path) {
      this.currentMode = path && path.indexOf('/m') === 0 ? 'mobile' : 'pc'
    },

    /**
     * 窗口尺寸稳定后的回调（由 resizeMixin 触发）
     * 尺寸跨过判定阈值时，自动在 PC / 移动端布局间切换
     * @param {number} width  window.innerWidth
     * @param {number} height window.innerHeight
     */
    handleResize(width, height) {
      // 复用路由守卫同一套检测逻辑（UA + 宽度），保证判定一致，避免来回跳转
      const mode = isMobileDevice() ? 'mobile' : 'pc'
      // 模式未变化则不做任何跳转（避免冗余 replace）
      if (mode === this.currentMode) return

      const path = this.$route.path
      const isMobileRoute = path.indexOf('/m') === 0
      let target = ''

      if (mode === 'mobile' && !isMobileRoute) {
        target = pathMap[path]
      } else if (mode === 'pc' && isMobileRoute) {
        target = pcMap[path]
      }
      // 当前路径不在映射表内（如 404）则跳过
      if (!target) return

      // 保留 query 参数，避免切换布局后丢失（如 ?index=3 的分类）
      const full = this.$route.fullPath
      const q = full.indexOf('?') >= 0 ? full.substring(full.indexOf('?')) : ''

      this.currentMode = mode
      this.$router.replace(target + q).catch(() => {})
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFangSC-Regular','Microsoft YaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue